/* unplugin-vue-components disabled */import { render } from "./E808CRender.vue?vue&type=template&id=0dd43f6e&scoped=true"
import script from "./E808CRender.vue?vue&type=script&lang=js"
export * from "./E808CRender.vue?vue&type=script&lang=js"

import "./E808CRender.vue?vue&type=style&index=0&id=0dd43f6e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dd43f6e"]])

export default __exports__